import { PipeTransform, Pipe } from '@angular/core';
import { enumToList } from '../enum-to-list';
import { IdName } from 'src/app/shared/models/id-name.model';
import { Doc } from 'src/app/shared/enums/docs.enum';

@Pipe({
  name: 'getDoc',
  standalone: false
})
export class DocPipe implements PipeTransform {
  public transform(value: Doc): string {
    return getDoc(value);
  }
}

export function getDoc(value: Doc): string {
  switch (value) {
    case Doc.Pdf:
      return 'pdf';
    case Doc.Doc:
      return 'doc';
    case Doc.Docx:
      return 'docx';
    case Doc.Jpg:
      return 'jpg';
    case Doc.Png:
      return 'png';
    case Doc.Bmp:
      return 'bmp';
    case Doc.Gif:
      return 'gif';
    case Doc.Xlsx:
      return 'xlsx';
    case Doc.Wpd:
      return 'wpd';
    default:
      throw new Error(`Unsupported value for Doc: ${value}.`);
  }
}

export function getDocList(): IdName[] {
  return enumToList(Doc, getDoc);
}
